var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_c('v-container',[_c('v-row',[_c('v-col',[_c('memo-card',{attrs:{"title":_vm.capitalize(this.memo.title),"user_id":this.memo.user_id,"date":this.memo.date,"description":this.memo.description,"id-link":this.memo.id}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }